export const FAQS = [
  {
    id: 1,
    question: 'What size should I get for my dog?',
    answer: 'We recommend a medium-sized scooper for dogs that weigh less than 50 lbs (22kg), and a large scooper for dogs 50 lbs (22kg) and up.',
  },
  {
    id: 2,
    question: 'Does the scooper come with bags?',
    answer: 'Yes, it includes 1 roll of waste bags for each scooper.',
  },
  {
    id: 3,
    question: 'Can I use my own bag?',
    answer: 'Yes, but we recommend using our bag. It fits perfectly! Just be sure to pick the matching size for your scooper when purchasing our bags.',
  },
  {
    id: 4,
    question: 'Does it work on all surfaces — grass, gravel, pavement?',
    answer: 'Yes! Our scooper is designed to work on multiple surfaces including grass, gravel, and pavement. Whether you\'re on a walk or cleaning up the backyard, it handles any terrain with ease.',
  },
  {
    id: 5,
    question: 'How do I clean the scooper after use?',
    answer: 'Simply rinse with water and a drop of dish soap. All models are made from non-porous, odor-resistant materials that clean up in seconds. They\'re also dishwasher-safe on the top rack.',
  },
  {
    id: 6,
    question: 'What is your return policy?',
    answer: 'We offer a 30-day hassle-free return policy. If you\'re not completely satisfied, contact us and we\'ll make it right — no questions asked. Your satisfaction is our priority.',
  },
  {
    id: 7,
    question: 'How long does shipping take?',
    answer: 'Standard shipping takes 3–5 business days within the US. We also offer express 1–2 day shipping at checkout. All orders over $50 qualify for free standard shipping.',
  },
];
